import { Form } from 'antd'
import { ButtonCommon, InputCommon, ModalCommon, RequireTag, SelectCommon } from '../../../components'
import styles from './index.module.scss'
import clsx from 'clsx'
import { openNotificationWithIcon, useGetStaffSuggest } from '../../../hooks'
import { useMutation } from 'react-query'
import { TerminalApi } from '../../../apis'
import { ITerminal } from '../../../models'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface IProps {
  dataDetail?: any
  title: string
  visible: boolean
  onOk: () => void
  onCancel: () => void
  id?: string
  setLoading: any
  refetch: () => void
  listStaff?: any
}

export const TerminalModal = ({ dataDetail, title, visible, setLoading, refetch, onOk, onCancel }: IProps) => {
  const { data: listStaff, isLoading: isLoadingListStaff } = useGetStaffSuggest({})
  const {t,i18n} = useTranslation()
  useEffect(() => {
    if (dataDetail) {
      form.setFieldsValue({
        user_id: dataDetail.user_id,
        device_name: dataDetail.device_name,
        device_id: dataDetail.device_id,
      })
    }
  }, [dataDetail])
  const [form] = Form.useForm()
  const { mutate: mutateCreate } = useMutation((body: ITerminal) => TerminalApi.createMAC(body), {
    onSuccess: () => {
      refetch()
      setLoading(false)
      onCancel()
      openNotificationWithIcon('success', t('terminal.message.createSuccess'))
    },
    onError: (error: any) => {
      setLoading(false)
      openNotificationWithIcon('error', error?.message)
    },
  })
  const { mutate: mutateUpdate } = useMutation((body: ITerminal) => TerminalApi.updateMAC(dataDetail.id, body), {
    onSuccess: () => {
      refetch()
      setLoading(false)
      onCancel()
      openNotificationWithIcon('success', t('terminal.message.updateSuccess'))
    },
    onError: (error: any) => {
      setLoading(false)
      openNotificationWithIcon('error', error?.message)
    },
  })
  const onFinish = (value: ITerminal) => {
    dataDetail ? mutateUpdate(value) : mutateCreate(value)
    setLoading(true)
  }

  return (
    <ModalCommon destroyOnClose={true} title={title} visible={visible} onOk={onOk} onCancel={onCancel} width="850px">
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <div className={clsx(styles.form__terminal)}>
          <Form.Item
            label={
              <>
                {t('terminal.title')}
                <RequireTag />
              </>
            }
            rules={[
              {
                required: true,
                message: t('terminal.message.userIdRequired'),
              },
            ]}
            style={{ marginBottom: '8px' }}
            name="user_id"
            validateTrigger="onSubmit"
          >
            <SelectCommon
              loading={isLoadingListStaff}
              maxTagCount="responsive"
              showSearch
              placeholder={t('terminal.placeholderSelect')}
              filterOption={(input, option) => `${option?.label}`.toLowerCase().includes(input.toLowerCase())}
              options={
                listStaff
                  ?.filter((item: any) => item.status !== '0')
                  ?.map((item: any) => ({ label: item?.username, value: item?.user_id, key: item?.user_id }))
              }
            />
          </Form.Item>
          <Form.Item
            label={<>{t('terminal.device')}</>}
            style={{ marginBottom: '8px' }}
            name={'device_name'}
            validateTrigger="onSubmit"
            initialValue={''}
          >
            <InputCommon maxLength={50} placeholder={t('terminal.placeholderInput')} />
          </Form.Item>
          <Form.Item
            label={
              <>
                {t('terminal.MAC')}
                <RequireTag />
              </>
            }
            rules={[
              {
                required: true,
                message: t('terminal.message.MACRequired'),
              },
            ]}
            style={{ marginBottom: '0' }}
            name={'device_id'}
            validateTrigger="onSubmit"
            initialValue={''}
          >
            <InputCommon maxLength={50} placeholder={t('terminal.placeholderInput')} />
          </Form.Item>
        </div>
        <div className={styles.form__terminal__footer}>
          <ButtonCommon type="ghost" onClick={onCancel}>
            {t('terminal.buttonCancel')}
          </ButtonCommon>
          <ButtonCommon lang={i18n.language} type="primary" htmlType="submit" >
            {t('terminal.buttonCreate')}
          </ButtonCommon>
        </div>
      </Form>
    </ModalCommon>
  )
}
